import React from 'react'
import './Dropdown.css'
import { AnimatePresence, motion } from 'framer-motion'
import { Link } from 'react-router-dom'

export default function Dropdown(props) {



    return (
        <AnimatePresence>
            {
                props.isActive && (

                    <motion.div className='dropdown-container' isActive={props.isActive}>
                        <motion.nav
                            className='dropdown'
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}>
                            {props.navitems.map((ele) => {
                                return <DropdownItem itemName={ele.item} route={ele.route} onClick={props.onItemClick} />
                            })}
                        </motion.nav>
                    </motion.div>
                )
            }

        </AnimatePresence>
    )
}

function DropdownItem(props) {
    return (
        <Link style={{
            'width' : '100%',
            'display' : 'flex',
            'justifyContent' : 'center'
        }} to={props.route} onClick={props.onClick}>
            <a className='dropdown-item' >
                {props.itemName}
            </a>

        </Link>
    )
}

